import React from 'react';
import { ChevronLeftIcon } from 'lucide-react';
import { PackageStatusPill } from './ui/StatusPill';
import { loan } from '../data/loan';
import type { PackageStatus, Scenario } from '../types/disclosures';
const scenarioOptions: {
  value: Scenario;
  label: string;
}[] = [{
  value: 'ready',
  label: 'Happy path'
}, {
  value: 'issues',
  label: 'Validation issues'
}, {
  value: 'locked',
  label: 'Loan locked'
}, {
  value: 'already_sent',
  label: 'Already sent'
}, {
  value: 'no_package',
  label: 'No package available'
}, {
  value: 'connection',
  label: 'Connection failure'
}];
interface LoanHeaderProps {
  status: PackageStatus;
  scenario: Scenario;
  onScenarioChange: (scenario: Scenario) => void;
}
export function LoanHeader({
  status,
  scenario,
  onScenarioChange
}: LoanHeaderProps) {
  return <header className="border-b border-slate-200 bg-white" data-id="element-152" data-mp="b4lys8w28f1s">
      <div className="mx-auto flex w-full max-w-[1160px] flex-col gap-3 px-6 py-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-153" data-mp="b3ayij1tppff">
        <div className="flex items-start gap-3" data-id="element-154" data-mp="1w6qtjmkcmzz0">
          <button type="button" className="mt-0.5 hidden rounded-md p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 sm:block" aria-label="Back to loan record" data-id="element-155" data-mp="1w5fsvvm7a8c4">
            <ChevronLeftIcon className="h-4 w-4" data-id="element-156" data-mp="20yqzbvn3on3i" />
          </button>
          <div data-id="element-157" data-mp="1d9fua1ypw6jk">
            <h1 className="text-[17px] font-semibold leading-6 tracking-[-0.01em] text-slate-900" data-id="element-158" data-mp="1d8wofjmcd8lw">
              Initial Disclosures
            </h1>
            <p className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[13px] text-slate-500" data-id="element-159" data-mp="1n6av4rigqj10">
              <span className="text-slate-700" data-id="element-160" data-mp="1i6y6c18171vs">
                {loan.street}, {loan.cityStateZip}
              </span>
              <span aria-hidden="true" className="text-slate-300" data-id="element-161" data-mp="2ykoepk66ocb8">
                •
              </span>
              <span data-id="element-162" data-mp="2tluxphrou36b">Borrower: {loan.primaryBorrower}</span>
              <span aria-hidden="true" className="text-slate-300" data-id="element-163" data-mp="30q34tdssd4ev">
                •
              </span>
              <span data-id="element-164" data-mp="35ony0t9mentt">Loan #: {loan.loanNumber}</span>
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3" data-id="element-165" data-mp="3aoaa2zdppy11">
          <label className="flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wide text-slate-400" data-id="element-166" data-mp="3aok2etm8ch9w">
            <span className="hidden sm:inline" data-id="element-167" data-mp="3fl0vm28adltu">Demo</span>
            <select value={scenario} onChange={event => onScenarioChange(event.target.value as Scenario)} className="rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-medium normal-case tracking-normal text-slate-600 focus:border-slate-400 focus:outline-none" aria-label="Demo scenario" data-id="element-168" data-mp="2i0egw4ncqo90">
              {scenarioOptions.map(option => <option key={option.value} value={option.value} data-id="element-169" data-mp="1z8lmc5smwuz6">
                  {option.label}
                </option>)}
            </select>
          </label>
          <PackageStatusPill status={status} data-id="element-170" data-mp="lbiy7qsxeex0" />
        </div>
      </div>
    </header>;
}